class StickyImages extends HTMLElement {
  constructor() {
    super();
    this.activeIndex = 0;
    this.ticking = false;
    this.onScroll = this.onScroll.bind(this);
  }

  connectedCallback() {
    this.viewport = this.querySelector('.sticky-viewport');
    this.images = Array.from(this.querySelectorAll('.stack-image-card'));
    this.textSlides = Array.from(this.querySelectorAll('.text-slide-item'));
    this.totalImages = this.images.length;
    
    if (this.totalImages === 0) return;

    // Set the track height. We use 100vh per slide to ensure native scroll feels smooth
    // On mobile, CSS overrides this to height:auto, so this value only affects desktop
    this.style.height = `${this.totalImages * 100}vh`;

    this.updateStack(0);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });
    
    // Initial check in case user loads halfway down the page
    this.onScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
  }

  onScroll() {
    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.calculateScrollProgress();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }

  calculateScrollProgress() {
    const rect = this.getBoundingClientRect();
    
    // Total distance the user must scroll to complete the section
    const scrollableDistance = rect.height - window.innerHeight;
    
    // How far down the track they currently are
    let scrolled = -rect.top;
    
    // Clamp values so we don't index out of bounds
    scrolled = Math.max(0, Math.min(scrolled, scrollableDistance));

    // Calculate percentage (0.0 to 1.0)
    const progress = scrollableDistance > 0 ? scrolled / scrollableDistance : 0;
    
    // Determine which slide to show based on percentage
    let newIndex = Math.floor(progress * this.totalImages);
    newIndex = Math.min(newIndex, this.totalImages - 1);

    if (newIndex !== this.activeIndex) {
      this.updateStack(newIndex);
    }
  }

  updateStack(activeIndex) {
    this.activeIndex = activeIndex;

    // 1. UPDATE IMAGES (Cycling Logic)
    this.images.forEach((img, i) => {
      img.classList.remove('is-active', 'is-next', 'is-back');

      // Modulo math ensures the cards loop to the back of the deck
      const stackPos = (i - activeIndex + this.totalImages) % this.totalImages;
      
      // Control layering: active is highest z-index
      img.style.zIndex = this.totalImages - stackPos;

      if (stackPos === 0) {
        img.classList.add('is-active'); // Current top card
      } else if (stackPos === 1) {
        img.classList.add('is-next');   // Middle card
      } else {
        img.classList.add('is-back');   // Cycled to the back
      }
    });

    // 2. UPDATE TEXT SLIDES
    if (this.textSlides.length > 0) {
      this.textSlides.forEach((slide, i) => {
        if (i === activeIndex) {
          slide.classList.add('is-active');
        } else {
          slide.classList.remove('is-active');
        }
      });
    }
  }
}

customElements.define('sticky-images-component', StickyImages);